import { ChevronDown } from "lucide-react";

export default function Topbar({ title, subtitle, universityName }) {
  return (
    <header className="topbar">

      <div>
        <h2>{title || "Dashboard"}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>

      <div className="topbar-user">

        <div className="avatar">
          A
        </div>

        <div>

          <strong>Administrator</strong>

          <p>{universityName || "University"}</p>

        </div>

        <ChevronDown size={16} aria-hidden="true" />

      </div>

    </header>
  );
}
